<template>
    <div class="details">
        <div class="tab_box">
            <div class="tab_term" 
                v-for="(item,index) of tab" :key="index"
                :class="item.id==isselect?'select':''"
                @click="switchtab(item)"
            >
                {{ item.name }}</div>
        </div>
        <div class="details_table">
            <el-table
                :data="tableData"
                :header-cell-style="{background:'#DCDFE6'}"
                style="width: 100%;">
                <el-table-column
                    prop="title"
                    min-width="30%"
                    show-overflow-tooltip
                    label="文章标题">
                </el-table-column>
                <el-table-column
                    label="权限"
                    align="center"
                    min-width="30%"
                    >
                    <template slot-scope="scope">
                        <div v-if="scope.row.authName=='普通会员'">全部可看</div>
                        <div v-else>{{ scope.row.authName}}</div>
                        
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    min-width="30%"
                    label="发表时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="10%">
                    <template slot-scope="scope">
                        <el-button type="text" @click="see(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination_box">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.currentPage"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="page.totalElements">
                </el-pagination>
            </div>
            
        </div>
    </div>
</template>
<script>
import basevideo from '../../utils/video'
    export default{
        data(){
            return{
                tab:null,
                isselect:null,
                tableData: [],
                page:{
                    pageindex:1,
                    pagesize:10,
                    currentPage:1,
                    totalElements:0,
                },
                user:null,
            }
        },
        created(){
            // console.log(this.$route.query.type);
            this.user=JSON.parse( sessionStorage.getItem('web_user'))
            // console.log(1111,this.user);
            this.isselect=this.$route.query.type
            this.tabaxios()
            this.tableaxios(this.isselect)
        },
        methods:{
            //
            see(scope){
                
                this.$webhttp.get(`/member/article?id=${scope.id}`).then((res)=>{
                    if(res.code==200){
                        console.log(115,res);
                        var pattern = new RegExp("yituo/image/","g");
                        res.data.content=res.data.content.replace(pattern,`${basevideo}yituo/image/`)
                    //    this.$store.commit('listing', res.data)
                        sessionStorage.setItem('listing',JSON.stringify( res.data))
                    //    console.log(123,this.$store.state.listing);
                       
                       let routeData =this.$router.resolve({path:'/listing'})

                        window.open(routeData.href, '_blank');
                    }else{
                        // console.log(111)
                        this.$message({
                            message:res.message,
                            type:'error'
                        })
                    }
                })
                
                // sessionStorage.setItem('listring',JSON.stringify( scope))
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.page.pagesize=val
                this.tableaxios(this.isselect)
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.page.pageindex=val
                this.tableaxios(this.isselect)
                
            },
            tableaxios(type){
                this.$webhttp.get(`/member/page/article?pageIndex=${this.page.pageindex}&pageSize=${this.page.pagesize}&moduleId=${type}`).then((res)=>{
                    if(res.code==200){
                        this.tableData=res.data.data
                        this.page.totalElements=res.data.totalElements
                        // console.log(1515,this.page);
                    }
                })
            },
            //切换tab
            switchtab(item){
                console.log(111,item);
                this.page.pageindex=1;
                this.page.pagesize=10
                this.$webhttp.post(`/hits/module?id=${item.id}`).then((res)=>{})
                this.isselect=item.id
                this.tableaxios(this.isselect)

            },
            //请求tab数据
            tabaxios(){
                this.$webhttp.get('module').then((res)=>{
                    // console.log(151,res);
                    if(res.code==200){
                        for(let i=0;i<res.data.length;i++){
                            if(res.data[i].id==8){
                                res.data.splice(i,1)
                            }
                        }
                        this.tab=res.data
                        
                    }
                })
            }
        },
    }
</script>
<style lang="less" scoped>
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #0A6EBA;
}
.details{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .tab_box{
        width: 60%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .tab_term{
            width: 13%;
            height:48px ;
            border: 1px solid #A7B4C5;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 4px; 
            cursor:pointer
        }
        .select{
            color: red;
            background: #0A6EBA;
            color: #FFFFFF;
        }
    }
    .details_table{
        width: 60%;
        height: 800px;
        box-sizing: border-box;
        margin-top: 15px;
        .pagination_box{;
            display: flex;
            justify-content:flex-end;
            margin-top: 20px;
        }
    }
}
</style>